import $ from 'jquery';
import run from '../../../utilities/run';
import render from "../../../utilities/render";
import resourceProgress from "../../../components/resourceProgress/resourceProgress";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../../constants";
import SUCCESS_MODAL_TIMEOUT from "../../../constants/index.js";
import {doAjax} from "../../../utilities/filtersutil";
import PagableComponent from '../../../components/pagableComponent/index';
const reviewWarehouseProductTemplate = require("../html/rmaReviewReturnProductWithRtv.html");

run("#rma-details", (mainEl) => {
    const resourceProgressTargetEl = mainEl.find('.resource-progress-target');
    const resourceStatusDemo = resourceProgressTargetEl.data('resource-progress-config');
    resourceProgress(resourceProgressTargetEl, { data: resourceStatusDemo });
    const portletNamespace =  mainEl.data("portlet-namespace");
    const vendorAuthorizationBtn = mainEl.find(".vendor-authorization-btn");
    const updateVendorAuthModal = $("#vendor-rma-auth-number");
    const vendorAuthButton =  updateVendorAuthModal.find("#vendor-auth-button");
    const updateVendorAuthForm = updateVendorAuthModal.find("#update-vendor-auth-numbers-frm");
    mainEl.on("click", '.address-id-missing-resubmit', resubmitRma);
    const addressIdMissingResubmit = $('.address-id-missing-resubmit');
    const missingAddressIdResubmitForm = $('#missing-address-id-resubmit-form');
    const trackShipmentbtn = mainEl.find(".track-shipment-btn");
    const rmaRetailerId = mainEl.data("rma-retailer-id");
    const rmaStatus = mainEl.data("rma-status");
    const rmaId = mainEl.data("rma-id");
    const reapproveRmaBtn = mainEl.find('#reapprove-rma');
    const changeRmsStatusUrl = mainEl.data("change-rms-status");
    const showCancelRmaModal = mainEl.find('#cancel-rma');
    const cancelRmaModal = $("#rma-cancel-modal");
    const rmaCancelBtn = cancelRmaModal.find("#cancel-rma-btn");
    const loadMoreItemsUrl = mainEl.data("load-more-items-url");
    const rmaItems = mainEl.data("rma-items");

    //show Reject Return modal for WB2 Pending RMA
    const showRejectReturnRmaModal = mainEl.find('#rejectreturn-rma'); //WB2
    const rejectReturnRmaModal = $("#rma-rejectreturn-modal");
    const rmaRejectReturnBtn = rejectReturnRmaModal.find("#rejectreturn-rma-btn"); //WB2 modal reject button
    
    //show Approve modal for WB2 pending RMA    
    const showApproveReturnRmaModal = mainEl.find('#approvereturn-rma'); //WB2
    const approveReturnRmaModal = $("#rma-approvereturn-modal");
    const rmaApproveReturnBtn = approveReturnRmaModal.find("#submitapprovereturn-rma-btn"); //WB2 modal approve submit button

    //Used by Reject Return button on details page WB2
    showRejectReturnRmaModal.on('click', function(e){
      rejectReturnRmaModal.show();
    });

    //Used by Reject Return button on modal popup WB2
    rmaRejectReturnBtn.on('click', function(e){
      changeRmaStatus("RMA Rejected");
    });

     //Used by Approve button on details page WB2
     showApproveReturnRmaModal.on('click', function(e){
      approveReturnRmaModal.show();
    });

     //Used by Approve button on modal popup WB2
    rmaApproveReturnBtn.on('click', function(e){
      changeRmaStatus("Approved");
    });

     showCancelRmaModal.on('click', function(e){
      cancelRmaModal.show();
    });

    reapproveRmaBtn.on('click', function(e){
      changeRmaStatus("Approved");
    });

    rmaCancelBtn.on('click', function(e){
      changeRmaStatus("Canceled");
    });

    function changeRmaStatus(newRmaStatus){
      var submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      submitModalFlow.showLoadingModal();  
        $.ajax({
            url: changeRmsStatusUrl,
            type: 'POST',
            dataType: 'text',
            data: {
                rmaStatus: newRmaStatus,
                selectedRmaId: rmaId
            },
            success: function (data) {
                if (data.trim() == "Approved") {
                  $('#rma-status').text('Approved')
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() { 
                    location.reload();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                }
                else {
                  $('#rma-status').text('Canceled')
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() { 
                    location.reload();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                }
               
            }
        });
    };

    

    trackShipmentbtn.on("click", function(e){
      //processReturnTracking($(this).attr('box-tracking-number'), rmaRetailerId);
      processReturnTracking($(this).data('box-tracking-number'), rmaRetailerId);
    });

    updateVendorAuthForm.validate({
      errorPlacement: function(error, element) {

        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    });

    vendorAuthorizationBtn.on('click',function(){
      updateVendorAuthModal.modal('show');
    });

    vendorAuthButton.on('click', function(e) {
        e.preventDefault();
          if(updateVendorAuthForm.valid()){
          updateVendorAuthModal.modal('hide');
          let updateActionUrl = $(this).attr("href");

          //console.log("will invoke ajax : " + updateActionUrl);

          const submitModalFlow = new SubmitModalFlow({
              confirmModalTitle: 'Submit Vendor Authorization Numbers',
              confirmModalBody: '<div class="q-pad-all-xl">Submitting this Vendor Authorization Number will update the status of this RMA to approved and the customer will receive their return shipping label.</div>',
              confirmModalBtnText: 'Submit',
              onConfirmClick: function() {
                  submitModalFlow.hideAllModals();
                  submitModalFlow.showLoadingModal();
                  let formData = $(updateVendorAuthForm).serialize();
                  $.ajax({
                      url: updateActionUrl,
                      type: 'POST',
                      data: formData,
                      success: function(resp) {
                          submitModalFlow.showSuccessModal();
                          setTimeout(function() {
                              window.location.reload();
                          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                      },
                      error: function(error) {
                          //submitModalFlow.showFailureModal();
                      }
                  });
              }
          });
          submitModalFlow.init();
          submitModalFlow.showConfirmModal();
        }
    });

    function resubmitRma() {
        //e.preventDefault();
        let url = addressIdMissingResubmit.data('url');
        const submitModalFlow = new SubmitModalFlow({
            confirmModalTitle: 'Resubmit RMA',
            confirmModalBody: '<div class="q-pad-all-xl">Resubmitting this RMA will check missing address id in system and change rma status accordingly.</div>',
            confirmModalBtnText: 'Submit',
            onConfirmClick: function() {
                submitModalFlow.hideAllModals();
                submitModalFlow.showLoadingModal();
                let formData = $(missingAddressIdResubmitForm).serialize();
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: {'rmaId':$('.missing-add-id-form-rmaid').val()},
                    success: function(resp) {
                        submitModalFlow.showSuccessModal();
                        setTimeout(function() {
                            window.location.reload();
                        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                    },
                    error: function(error) {
                        //submitModalFlow.showFailureModal();
                    }
                });
            }
        });
        submitModalFlow.init();
        submitModalFlow.showConfirmModal();
    }

    function processReturnTracking(trackingNumber, retailerId) {
      AUI().use('liferay-portlet-url', function(A) {
          let renderURL = Liferay.PortletURL.createRenderURL();
          renderURL.setName("shipmentTracking");
          renderURL.setWindowState("exclusive");
          renderURL.setPortletId("shipmenttracking_WAR_commerceportlet");
          renderURL.setParameter("tracking-number", trackingNumber);
          renderURL.setParameter("carrier", "Fedex");
          renderURL.setParameter("retailerId", retailerId);
          let url = renderURL.toString();

      $(`#${portletNamespace}trackingLoading`).show();
      $(`#${portletNamespace}trackingError`).hide();
      $(`#${portletNamespace}trackingDiv`).html("");
      $("#trackingModal").modal("show");

          $.ajax({
            url: url,
            cache: false,
            type: "POST",
            success: function(response) {
              $(`#${portletNamespace}trackingLoading`).hide();
                $(`#${portletNamespace}trackingDiv`).html(response);
            },
            error: function(){
              $(`#${portletNamespace}trackingError`).show();
            }
        });
      });
  }
  const pageSizeOptionsArray = [25,50,100];
  const pageSize =  25; //default to 25 for the RMA Items 
  const pagableRmaItems = new PagableComponent({
    dataContainer: '.render-area-for-product-with-rtv',
    pagingContainer: '.paging-area-for-product-with-rtv',
    pageSizeOptions:pageSizeOptionsArray,
    pageSize: pageSize,
    data: rmaItems,
    showData: function (row) {
      return render(reviewWarehouseProductTemplate, {
        sku: row.rmaItemSku,
        upc: row.rmaItemUpc,
        modal: row.rmaItemModel,
        qty: row.rmaItemQty,
        rtv: row.rmaItemRtvNumber
      });
    },
    onFetch: function (page, pageSize) {
      pagableRmaItems.showLoadingOverlay();
      setTimeout(() => {
        doAjax({url: loadMoreItemsUrl, success: loadMoreItems, error: errorFun, data:prepareDataToSendController(rmaId, page, pageSize)});
      },SUCCESS_MODAL_TIMEOUT);
    }
  });

  function loadMoreItems(data){
    let rmaItems = data.content;
    pagableRmaItems.setData(rmaItems);
    pagableRmaItems.hideLoadingOverlay();
  }

  function errorFun(data){
    pagableRmaItems.hideLoadingOverlay();
  }

  function prepareDataToSendController(rmaId, page, pageSize){
    let data={
      page: page,
      pageSize: pageSize,
      rmaId: rmaId
    }
    return data;
  }
  pagableRmaItems.init();
});



// WEBPACK FOOTER //
// ./src/pages/rma/rmaDetails/rmaDetails.js